/**
 * ROLES UTILISATEURS - Constantes centralisées (Frontend)
 * Chaque utilisateur doit avoir UN SEUL rôle, peu importe les cabines
 */

export const ROLE_VALUES = {
  CONSULTATION: 1,      // Accès lecture seule
  CALIBRATION: 8,       // Accès étalonnage
  ADMIN: 256,           // Accès complet cabine
  OWNER: 2147483647,    // Propriétaire (spécial, rarement utilisé pour les invités)
};

export const VALID_ROLES = [1, 8, 256, 2147483647];

export const ROLE_LABELS = {
  1: "roles.consultation",
  8: "roles.calibration",
  256: "roles.admin",
  2147483647: "roles.owner",
};

export const DEFAULT_ROLE = ROLE_VALUES.CONSULTATION; // 1

// Fonction helper : convertir rôle numérique → libellé (i18n key)
export const getRoleLabel = (roleValue) => {
  return ROLE_LABELS[roleValue] || "team.no_right";
};

// Fonction helper : vérifier si rôle valide
export const isValidRole = (roleValue) => {
  return VALID_ROLES.includes(Number(roleValue));
};
